import React from 'react';
import styled, { css } from 'styled-components';

const StyledFormElement = styled.div`
  margin-bottom: 1rem;
  ${p =>
    p.appearance === 'row' &&
    css`
      display: flex;
      align-items: center;
    `}
`;

const FormElement = ({ children, disabled, ...props }) => (
  <StyledFormElement disabled={disabled} {...props}>
    {children}
  </StyledFormElement>
);

export default FormElement;
